import { render, staticRenderFns } from "./manage-admin.vue?vue&type=template&id=a068545c&scoped=true"
import script from "./manage-admin.vue?vue&type=script&lang=ts&setup=true"
export * from "./manage-admin.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./manage-admin.vue?vue&type=style&index=0&id=a068545c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a068545c",
  null
  
)

export default component.exports